import 'css-chunksrc/client/common/listSelect/styles.scss';export default {
  "selectList": "_selectList_1sxtq_1",
  "input": "_input_1sxtq_7",
  "selectedItems": "_selectedItems_1sxtq_23",
  "selectedItem": "_selectedItem_1sxtq_23",
  "list": "_list_1sxtq_45",
  "layoutWatcher": "_layoutWatcher_1sxtq_62",
  "selectedListItem": "_selectedListItem_1sxtq_66",
  "iconBox": "_iconBox_1sxtq_70",
  "icon": "_icon_1sxtq_70",
  "placeholder": "_placeholder_1sxtq_84",
  "opened": "_opened_1sxtq_89",
  "invalid": "_invalid_1sxtq_99"
};